import React from "react";
import { useNavigate } from "react-router-dom";
import "./errorpage.css";
import NotFoundImage from "../../Assets/404.png";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-container">
      <img src={NotFoundImage} alt="404 Not Found" className="notfound-image" />
      <p className="notfound-text">Oops! The page you are looking for does not exist.</p>
      <button className="notfound-button" onClick={() => navigate("/")}>Back to Home</button>
    </div>
  );
};

export default NotFoundPage;